import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Phone, Mail, ArrowLeft, KeyRound } from 'lucide-react';

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md bg-zinc-900/50 border-zinc-800">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <KeyRound className="text-red-500" size={32} />
          </div>
          <CardTitle className="text-2xl text-white">Mot de passe oublié ?</CardTitle>
          <CardDescription className="text-zinc-400">
            Contactez-nous pour réinitialiser votre mot de passe
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-zinc-800/50 rounded-lg p-6 text-center">
            <p className="text-zinc-300 mb-4">
              Pour des raisons de sécurité, veuillez nous contacter directement pour réinitialiser votre mot de passe.
            </p>
            
            <div className="space-y-4">
              <a href="tel:0805032032" className="flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors">
                <Phone size={20} />
                0805 032 032
              </a>
              
              <a href="mailto:info@lehubatelier.fr?subject=Réinitialisation mot de passe" className="flex items-center justify-center gap-3 bg-zinc-700 hover:bg-zinc-600 text-white py-3 px-6 rounded-lg font-semibold transition-colors">
                <Mail size={20} />
                info@lehubatelier.fr
              </a>
            </div>
          </div>
          
          <div className="bg-zinc-800/30 rounded-lg p-4 text-sm text-zinc-400">
            <p className="mb-2">📞 Par téléphone : Du lundi au samedi, 8h00-19h30</p>
            <p>📧 Par email : Réponse sous 24h</p>
          </div>

          <div className="text-center">
            <Link to="/connexion" className="text-zinc-500 hover:text-white inline-flex items-center gap-2">
              <ArrowLeft size={16} />
              Retour à la connexion
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
